import React, { useState, useEffect } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import api from "assets/services/api";



function ModalDeleteTabulation(props) {
  const [br, setBR] = useState(false);
  const [controlSnack, setControlSnack] = useState(false);

  async function handleDeleteStorage(e) {
    e.preventDefault();
    const response = await api.delete('/tabulation/delete/'+props.props.id, {
    });
    if (response.status === 200) {
      setControlSnack(true);
      props.handleShowTabulation()
      props.onHide();
    }
  }

  const showNotification = place => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (controlSnack) {
        showNotification("br")
    }
  }, [controlSnack]);
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Deletar tabela de preço
          </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleDeleteStorage}>
        <Modal.Body>
        <h4> Tem certeza que deseja deletar essa tabela de preço?</h4>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit">
              Deletar
          </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message="tabela de preço deletado com sucesso"
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
        </Form>
    </Modal>
  );
}

export default ModalDeleteTabulation;